// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file qf/requests.proto (package qf, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Enrollment_UserStatus, Review, Submissions } from "./types_pb";
import { file_qf_types } from "./types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file qf/requests.proto.
 */
export const file_qf_requests: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_qf_types]);

/**
 * @generated from message qf.CourseSubmissions
 */
export type CourseSubmissions = Message<"qf.CourseSubmissions"> & {
  /**
   * @generated from field: map<uint64, qf.Submissions> submissions = 1;
   */
  submissions: { [key: string]: Submissions };
};

/**
 * Describes the message qf.CourseSubmissions.
 * Use `create(CourseSubmissionsSchema)` to create a new message.
 */
export const CourseSubmissionsSchema: GenMessage<CourseSubmissions> = /*@__PURE__*/
  messageDesc(file_qf_requests, 0);

/**
 * @generated from message qf.ReviewRequest
 */
export type ReviewRequest = Message<"qf.ReviewRequest"> & {
  /**
   * @generated from field: uint64 courseID = 1;
   */
  courseID: bigint;

  /**
   * @generated from field: qf.Review review = 2;
   */
  review?: Review | undefined;
};

/**
 * Describes the message qf.ReviewRequest.
 * Use `create(ReviewRequestSchema)` to create a new message.
 */
export const ReviewRequestSchema: GenMessage<ReviewRequest> = /*@__PURE__*/
  messageDesc(file_qf_requests, 1);

/**
 * @generated from message qf.CourseRequest
 */
export type CourseRequest = Message<"qf.CourseRequest"> & {
  /**
   * @generated from field: uint64 courseID = 1;
   */
  courseID: bigint;
};

/**
 * Describes the message qf.CourseRequest.
 * Use `create(CourseRequestSchema)` to create a new message.
 */
export const CourseRequestSchema: GenMessage<CourseRequest> = /*@__PURE__*/
  messageDesc(file_qf_requests, 2);

/**
 * @generated from message qf.GroupRequest
 */
export type GroupRequest = Message<"qf.GroupRequest"> & {
  /**
   * @generated from field: uint64 courseID = 1;
   */
  courseID: bigint;

  /**
   * @generated from field: uint64 userID = 2;
   */
  userID: bigint;

  /**
   * @generated from field: uint64 groupID = 3;
   */
  groupID: bigint;
};

/**
 * Describes the message qf.GroupRequest.
 * Use `create(GroupRequestSchema)` to create a new message.
 */
export const GroupRequestSchema: GenMessage<GroupRequest> = /*@__PURE__*/
  messageDesc(file_qf_requests, 3);

/**
 * @generated from message qf.Organization
 */
export type Organization = Message<"qf.Organization"> & {
  /**
   * @generated from field: uint64 ScmOrganizationID = 1;
   */
  ScmOrganizationID: bigint;

  /**
   * @generated from field: string ScmOrganizationName = 2;
   */
  ScmOrganizationName: string;
};

/**
 * Describes the message qf.Organization.
 * Use `create(OrganizationSchema)` to create a new message.
 */
export const OrganizationSchema: GenMessage<Organization> = /*@__PURE__*/
  messageDesc(file_qf_requests, 4);

/**
 * @generated from message qf.EnrollmentRequest
 */
export type EnrollmentRequest = Message<"qf.EnrollmentRequest"> & {
  /**
   * @generated from oneof qf.EnrollmentRequest.FetchMode
   */
  FetchMode: {
    /**
     * @generated from field: uint64 courseID = 1;
     */
    value: bigint;
    case: "courseID";
  } | {
    /**
     * @generated from field: uint64 userID = 2;
     */
    value: bigint;
    case: "userID";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: repeated qf.Enrollment.UserStatus statuses = 3;
   */
  statuses: Enrollment_UserStatus[];
};

/**
 * Describes the message qf.EnrollmentRequest.
 * Use `create(EnrollmentRequestSchema)` to create a new message.
 */
export const EnrollmentRequestSchema: GenMessage<EnrollmentRequest> = /*@__PURE__*/
  messageDesc(file_qf_requests, 5);

/**
 * @generated from message qf.SubmissionRequest
 */
export type SubmissionRequest = Message<"qf.SubmissionRequest"> & {
  /**
   * @generated from field: uint64 CourseID = 1;
   */
  CourseID: bigint;

  /**
   * only used for user and group submissions
   *
   * @generated from field: uint64 AssignmentID = 2;
   */
  AssignmentID: bigint;

  /**
   * @generated from oneof qf.SubmissionRequest.FetchMode
   */
  FetchMode: {
    /**
     * fetch single user's submissions with build info
     *
     * @generated from field: uint64 UserID = 3;
     */
    value: bigint;
    case: "UserID";
  } | {
    /**
     * fetch single group's submissions with build info
     *
     * @generated from field: uint64 GroupID = 4;
     */
    value: bigint;
    case: "GroupID";
  } | {
    /**
     * fetch single specific submission with build info
     *
     * @generated from field: uint64 SubmissionID = 5;
     */
    value: bigint;
    case: "SubmissionID";
  } | {
    /**
     * fetch all submissions of given type without build info
     *
     * @generated from field: qf.SubmissionRequest.SubmissionType Type = 6;
     */
    value: SubmissionRequest_SubmissionType;
    case: "Type";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message qf.SubmissionRequest.
 * Use `create(SubmissionRequestSchema)` to create a new message.
 */
export const SubmissionRequestSchema: GenMessage<SubmissionRequest> = /*@__PURE__*/
  messageDesc(file_qf_requests, 6);

/**
 * @generated from enum qf.SubmissionRequest.SubmissionType
 */
export enum SubmissionRequest_SubmissionType {
  /**
   * fetch all submissions
   *
   * @generated from enum value: ALL = 0;
   */
  ALL = 0,

  /**
   * fetch all user submissions
   *
   * @generated from enum value: USER = 1;
   */
  USER = 1,

  /**
   * fetch all group submissions
   *
   * @generated from enum value: GROUP = 2;
   */
  GROUP = 2,
}

/**
 * Describes the enum qf.SubmissionRequest.SubmissionType.
 */
export const SubmissionRequest_SubmissionTypeSchema: GenEnum<SubmissionRequest_SubmissionType> = /*@__PURE__*/
  enumDesc(file_qf_requests, 6, 0);

/**
 * used to check whether student/group submission repo is empty
 *
 * @generated from message qf.RepositoryRequest
 */
export type RepositoryRequest = Message<"qf.RepositoryRequest"> & {
  /**
   * @generated from field: uint64 userID = 1;
   */
  userID: bigint;

  /**
   * @generated from field: uint64 groupID = 2;
   */
  groupID: bigint;

  /**
   * @generated from field: uint64 courseID = 3;
   */
  courseID: bigint;
};

/**
 * Describes the message qf.RepositoryRequest.
 * Use `create(RepositoryRequestSchema)` to create a new message.
 */
export const RepositoryRequestSchema: GenMessage<RepositoryRequest> = /*@__PURE__*/
  messageDesc(file_qf_requests, 7);

/**
 * @generated from message qf.Repositories
 */
export type Repositories = Message<"qf.Repositories"> & {
  /**
   * Map key is the Repository.Type
   *
   * @generated from field: map<uint32, string> URLs = 1;
   */
  URLs: { [key: number]: string };
};

/**
 * Describes the message qf.Repositories.
 * Use `create(RepositoriesSchema)` to create a new message.
 */
export const RepositoriesSchema: GenMessage<Repositories> = /*@__PURE__*/
  messageDesc(file_qf_requests, 8);

/**
 * @generated from message qf.RebuildRequest
 */
export type RebuildRequest = Message<"qf.RebuildRequest"> & {
  /**
   * @generated from field: uint64 courseID = 1;
   */
  courseID: bigint;

  /**
   * @generated from field: uint64 assignmentID = 2;
   */
  assignmentID: bigint;

  /**
   * @generated from field: uint64 submissionID = 3;
   */
  submissionID: bigint;
};

/**
 * Describes the message qf.RebuildRequest.
 * Use `create(RebuildRequestSchema)` to create a new message.
 */
export const RebuildRequestSchema: GenMessage<RebuildRequest> = /*@__PURE__*/
  messageDesc(file_qf_requests, 9);

/**
 * NotesRequest fetches all internal notes relevant to a target.
 * Exactly one of submissionID, groupID, or enrollmentID should be set.
 * When submissionID is set, the response also includes notes attached to the
 * submission's group and the submitter's enrollment.
 *
 * @generated from message qf.NotesRequest
 */
export type NotesRequest = Message<"qf.NotesRequest"> & {
  /**
   * @generated from field: uint64 courseID = 1;
   */
  courseID: bigint;

  /**
   * @generated from field: uint64 submissionID = 2;
   */
  submissionID: bigint;

  /**
   * @generated from field: uint64 groupID = 3;
   */
  groupID: bigint;

  /**
   * @generated from field: uint64 enrollmentID = 4;
   */
  enrollmentID: bigint;
};

/**
 * Describes the message qf.NotesRequest.
 * Use `create(NotesRequestSchema)` to create a new message.
 */
export const NotesRequestSchema: GenMessage<NotesRequest> = /*@__PURE__*/
  messageDesc(file_qf_requests, 10);

/**
 * @generated from message qf.CourseLogRequest
 */
export type CourseLogRequest = Message<"qf.CourseLogRequest"> & {
  /**
   * @generated from field: uint64 courseID = 1;
   */
  courseID: bigint;

  /**
   * default: 1 hour before to
   *
   * @generated from field: qf.LogPosition from = 2;
   */
  from?: LogPosition | undefined;

  /**
   * default: now, and the stream keeps sending new entries
   *
   * @generated from field: qf.LogPosition to = 3;
   */
  to?: LogPosition | undefined;

  /**
   * exact match; unset selects every repository
   *
   * @generated from field: string repository = 4;
   */
  repository: string;

  /**
   * minimum level to include
   *
   * @generated from field: qf.CourseLogEntry.Level level = 5;
   */
  level: CourseLogEntry_Level;

  /**
   * default 2000, server maximum 5000
   *
   * @generated from field: uint32 limit = 6;
   */
  limit: number;

  /**
   * over the limit, send the newest entries rather than the oldest
   *
   * @generated from field: bool newest = 7;
   */
  newest: boolean;
};

/**
 * Describes the message qf.CourseLogRequest.
 * Use `create(CourseLogRequestSchema)` to create a new message.
 */
export const CourseLogRequestSchema: GenMessage<CourseLogRequest> = /*@__PURE__*/
  messageDesc(file_qf_requests, 11);

/**
 * @generated from message qf.CourseLogEntry
 */
export type CourseLogEntry = Message<"qf.CourseLogEntry"> & {
  /**
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp | undefined;

  /**
   * @generated from field: qf.CourseLogEntry.Level level = 2;
   */
  level: CourseLogEntry_Level;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * repository-relative file:line
   *
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * @generated from field: string repository = 5;
   */
  repository: string;

  /**
   * @generated from field: string repositoryType = 6;
   */
  repositoryType: string;

  /**
   * remaining structured attributes
   *
   * @generated from field: map<string, string> fields = 7;
   */
  fields: { [key: string]: string };

  /**
   * @generated from field: bool truncated = 8;
   */
  truncated: boolean;

  /**
   * unset for the stream's own gap reports
   *
   * @generated from field: qf.LogCursor cursor = 9;
   */
  cursor?: LogCursor | undefined;
};

/**
 * Describes the message qf.CourseLogEntry.
 * Use `create(CourseLogEntrySchema)` to create a new message.
 */
export const CourseLogEntrySchema: GenMessage<CourseLogEntry> = /*@__PURE__*/
  messageDesc(file_qf_requests, 12);

/**
 * @generated from enum qf.CourseLogEntry.Level
 */
export enum CourseLogEntry_Level {
  /**
   * @generated from enum value: DEBUG = 0;
   */
  DEBUG = 0,

  /**
   * @generated from enum value: INFO = 1;
   */
  INFO = 1,

  /**
   * @generated from enum value: WARN = 2;
   */
  WARN = 2,

  /**
   * @generated from enum value: ERROR = 3;
   */
  ERROR = 3,
}

/**
 * Describes the enum qf.CourseLogEntry.Level.
 */
export const CourseLogEntry_LevelSchema: GenEnum<CourseLogEntry_Level> = /*@__PURE__*/
  enumDesc(file_qf_requests, 12, 0);

/**
 * LogPosition is one end of a log range: a time, or an entry's cursor. A time
 * includes entries stamped at it; a cursor leaves out the entry it came from,
 * so a range can continue from an entry already shown without repeating it.
 *
 * @generated from message qf.LogPosition
 */
export type LogPosition = Message<"qf.LogPosition"> & {
  /**
   * @generated from oneof qf.LogPosition.position
   */
  position: {
    /**
     * @generated from field: google.protobuf.Timestamp time = 1;
     */
    value: Timestamp;
    case: "time";
  } | {
    /**
     * @generated from field: qf.LogCursor cursor = 2;
     */
    value: LogCursor;
    case: "cursor";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message qf.LogPosition.
 * Use `create(LogPositionSchema)` to create a new message.
 */
export const LogPositionSchema: GenMessage<LogPosition> = /*@__PURE__*/
  messageDesc(file_qf_requests, 13);

/**
 * LogCursor is the position just past an entry in a course's log. Unlike a
 * timestamp, it follows the order entries were written, and no two entries
 * share one. Clients should only send back cursors the server handed out.
 *
 * @generated from message qf.LogCursor
 */
export type LogCursor = Message<"qf.LogCursor"> & {
  /**
   * UTC midnight of the date file's day
   *
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp | undefined;

  /**
   * bytes into that file, just past the entry's newline
   *
   * @generated from field: uint64 offset = 2;
   */
  offset: bigint;
};

/**
 * Describes the message qf.LogCursor.
 * Use `create(LogCursorSchema)` to create a new message.
 */
export const LogCursorSchema: GenMessage<LogCursor> = /*@__PURE__*/
  messageDesc(file_qf_requests, 14);

/**
 * CourseLog is one message of a CourseLogStream. The first message holds the
 * backlog for the requested interval; each later message holds a single live
 * entry, and lists a repository only when that entry introduces a new one.
 *
 * @generated from message qf.CourseLog
 */
export type CourseLog = Message<"qf.CourseLog"> & {
  /**
   * in the order written, which may differ slightly from timestamp order
   *
   * @generated from field: repeated qf.CourseLogEntry entries = 1;
   */
  entries: CourseLogEntry[];

  /**
   * repositories with entries in the selected interval
   *
   * @generated from field: repeated string repositories = 2;
   */
  repositories: string[];

  /**
   * set when entries were cut off by the limit
   *
   * @generated from field: bool truncated = 3;
   */
  truncated: boolean;
};

/**
 * Describes the message qf.CourseLog.
 * Use `create(CourseLogSchema)` to create a new message.
 */
export const CourseLogSchema: GenMessage<CourseLog> = /*@__PURE__*/
  messageDesc(file_qf_requests, 15);

/**
 * RepositoryIssues reports the number of content problems found in a repository.
 * Details are available in the course log.
 *
 * @generated from message qf.RepositoryIssues
 */
export type RepositoryIssues = Message<"qf.RepositoryIssues"> & {
  /**
   * @generated from field: uint32 count = 1;
   */
  count: number;
};

/**
 * Describes the message qf.RepositoryIssues.
 * Use `create(RepositoryIssuesSchema)` to create a new message.
 */
export const RepositoryIssuesSchema: GenMessage<RepositoryIssues> = /*@__PURE__*/
  messageDesc(file_qf_requests, 16);

/**
 * @generated from message qf.Void
 */
export type Void = Message<"qf.Void"> & {
};

/**
 * Describes the message qf.Void.
 * Use `create(VoidSchema)` to create a new message.
 */
export const VoidSchema: GenMessage<Void> = /*@__PURE__*/
  messageDesc(file_qf_requests, 17);

